/**
 * Returns undefined if array is empty, otherwise returns the array.
 * Useful for GraphQL variables where undefined means "no filter"
 * and empty array might mean "match nothing".
 */
export const emptyToUndefined = <T>(arr: T[]): T[] | undefined =>
  arr.length > 0 ? arr : undefined;
